// extracted by mini-css-extract-plugin
module.exports = {"submitter-summary":"submitter-summary__3bLdO","submitter-label":"submitter-label__26hiK","submitter-profile-wrapper":"submitter-profile-wrapper__2bHpv"};